import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";

export default function Privacy() {
  const effective = new Date().toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" });
  return (
    <div className="mx-auto max-w-3xl px-4 py-6 sm:py-10">
      <Card className="elevated-card">
        <CardHeader>
          <CardTitle className="text-slate-900 dark:text-slate-100">Privacy Policy</CardTitle>
        </CardHeader>
        <CardContent className="space-y-5 text-slate-700 dark:text-slate-300">
          <div className="text-sm text-slate-500">Effective date: {effective}</div>

          <section>
            <h2 className="font-semibold text-slate-900 dark:text-slate-100">Who we are</h2>
            <p>
              This website (www.somemasrecovery.com) provides a free, self‑paced 27‑week course experience. We do not
              require account sign‑ups. Your course progress is stored locally on your device.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-slate-900 dark:text-slate-100">What we collect</h2>
            <ul className="list-disc ml-5 space-y-1">
              <li>Local data on your device (localStorage) for course progress, week/day checklists, and optional streak tracking.</li>
              <li>If you accept analytics cookies, we set an anonymous <code>visitor_id</code> cookie used for unique visitor counting, referral deduplication, and ad click deduplication.</li>
              <li>If you decline, analytics and ad-tracking cookies remain off and no new <code>visitor_id</code> is created.</li>
              <li>Basic diagnostic or performance logs required to operate the site (e.g., error logs).</li>
            </ul>
          </section>

          <section>
            <h2 className="font-semibold text-slate-900 dark:text-slate-100">Local storage on your device</h2>
            <p>
              We save progress locally using your browser’s storage (e.g., localStorage). This does not leave your
              device unless you choose to sync or export using a third party. Clearing your browser storage or using
              the in‑app Reset option will remove this data from your device.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-slate-900 dark:text-slate-100">Cookies and similar technologies</h2>
            <p>
              We use first-party cookies and local storage for essential app behavior. Separately, we ask for consent
              before enabling analytics/ad-tracking cookies. If accepted, the <code>visitor_id</code> cookie helps us
              avoid double-counting and hide ads you already clicked.
            </p>
            <p className="mt-2">
              You can choose <strong>Accept</strong> or <strong>Decline</strong> in the consent modal. Changing browser
              storage settings or clearing cookies may reset this preference.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-slate-900 dark:text-slate-100">Legal bases and your rights</h2>
            <ul className="list-disc ml-5 space-y-1">
              <li>We may process limited data to operate the site based on our legitimate interests (security, fraud prevention, service reliability).</li>
              <li>Your rights (depending on your region) may include access, deletion, correction, objection, restriction, and portability.</li>
            </ul>
            <p className="mt-2">
              To exercise rights or make privacy requests, contact us using the details below. We may ask for information to verify your request.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-slate-900 dark:text-slate-100">Children’s privacy</h2>
            <p>
              This site is not directed to children under the age of 13 (or other age as defined by local law). If you
              believe we have inadvertently collected information from a child, please contact us so we can delete it.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-slate-900 dark:text-slate-100">Data retention</h2>
            <p>
              Local progress data remains on your device until you clear it.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-slate-900 dark:text-slate-100">International transfers</h2>
            <p>
              Our providers may process data on servers located outside your country. We rely on appropriate safeguards
              where required by law.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-slate-900 dark:text-slate-100">Policy changes</h2>
            <p>
              We may update this Privacy Policy at any time. Changes will be posted on this page with an updated
              effective date. Continued use of the site after changes means you accept the updated policy.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-slate-900 dark:text-slate-100">Contact</h2>
            <p>
              For privacy requests or questions, contact the site owner at the email address listed on the site or your
              usual contact channel.
            </p>
          </section>
        </CardContent>
      </Card>
    </div>
  );
}